<div class="flex flex-middle w-12 pos-relative"
     style="min-height: 40px;">
    @if (image()) {
    <img [dfImage]="image()"
         [alt]="title()"
         ratio="1/1"
         width="40"
         height="40">
    }

    <div class="flex-grow p-r-10 p-l-2">
        @if (link()) {
        <href [link]="link()"
              (click)="handleLinkClick()">
            <div class="h5">{{ title() }}</div>
            @if (subtitle()) {
            <div class="p3 col-11">
                {{ subtitle() }}
            </div>
            }
        </href>
        } @else {
        <div class="h5">{{ title() }}</div>
        @if (subtitle()) {
        <div class="p3 col-11">
            {{ subtitle() }}
        </div>
        }
        }
    </div>

    <button class="pos-absolute top-1 right-0"
            (click)="handleClose()"
            aria-label="Close notification">
        <i class="icon-close p-a-1"
           style="font-size: 12px;"></i>
    </button>
</div>
